export default __webpack_public_path__ + "static/media/white-apes-banner2.99e21d30.png";